import { LeaderboardPlayerData } from "../../../models/leaderboard";
import { Group } from "../../../models/groupedTeams";
import { usePublicStore } from "../../../store/publicStore";
import { GroupLeaderboardTable } from "./GroupLeaderboardTable";
import { PlayerLeaderboardTable } from "./PlayerLeaderboardTable";
import { TeamLeaderboardTable } from "./TeamLeaderboardTable";

interface SeasonLeaderboardProps {
  data: LeaderboardPlayerData[];
  view: "group" | "team" | "player";
  groups: Group[];
}

export const SeasonLeaderboardTable = ({
  data,
  view,
  groups,
}: SeasonLeaderboardProps) => {
  const { matchSetups } = usePublicStore();

  return view === "group" ? (
    <GroupLeaderboardTable
      data={data}
      groups={groups}
      matchSetups={matchSetups.filter((m) => m.groupOrKnockout === "Group")}
    />
  ) : view === "team" ? (
    <TeamLeaderboardTable
      data={data}
      groups={groups}
      matchSetups={matchSetups.filter((m) => m.groupOrKnockout === "Group")}
    />
  ) : (
    <PlayerLeaderboardTable
      data={data}
      matchSetups={matchSetups.filter((m) => m.groupOrKnockout === "Group")}
    />
  );
};
